import { Button } from "antd";
import React from "react";
import { APK_DOWNLOAD_URL, PLAYSTORE_URL } from "../../constants/webapp";
import { LogoView } from "../../components/elements/LogoView";
import { secondaryColor } from "../../theme/Theme";

export const DownloadApp = () => {
  return (
    <>
      <div className="flexCenter vh100">
        <div className="flexColumn gap20" style={{ padding: 20 }}>
          <LogoView />
          <div className="flexColumn gap10 textCenter">
            <h1 style={{ color: secondaryColor, margin: 0 }}>
              Download Eight-8
            </h1>
            <p className="lightColor font13" style={{ marginBottom: 20 }}>
              You can download Eight-8 using any of the options below.
            </p>
          </div>

          <div className="flexColumn" style={{ gap: 30 }}>
            {[
              {
                label: "Download App",
                url: APK_DOWNLOAD_URL,
                title: "Direct Download (APK)",
                description:
                  "Download and install the .apk file on your device directly.",
              },
              {
                title: "Google Play",
                label: "Install on Google Play",
                description: "Download and install from Google Playstore.",
                url: PLAYSTORE_URL,
                props: {
                  target: "_blank",
                  type: "default",
                },
              },
            ].map(({ url, label, props, title, description }, i) => (
              <div key={i} className="flexColumn gap10">
                <p className="bold">{title}</p>
                <p className="lightColor font13">{description}</p>
                <Button type="primary" size="large" href={url} {...props}>
                  {label}
                </Button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
